import { CursorOverlay, CursorOverlayProps } from '@udecode/plate';
import { CSSProperties, useState } from 'react';

import { cursorStore } from './cursorStore';

interface CursorOverlayWithIdProps extends CursorOverlayProps {
  id?: string;
}

export const stringToColour = function (str) {
  try {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    let colour = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += ('00' + value.toString(16)).substr(-2);
    }
    return colour;
  } catch (e) {
    return 'red';
  }
};

export const CursorOverlayContainer = ({ cursors, id, ...props }: CursorOverlayWithIdProps) => {
  const dynamicCursors = cursorStore.use.cursors();
  const [isHovered, setIsHovered] = useState(false);

  const handleRender = (props) => {
    const { data, caretPosition } = props;

    const labelStyle: CSSProperties = {
      transform: 'translateY(-100%)',
      background: isHovered ? 'transparent' : data?.style?.backgroundColor,
      gridTemplateColumns: 'auto auto',
      color: isHovered ? 'transparent' : 'white',
    };

    return caretPosition ? (
      <div id="cursor-collab" style={{ ...caretPosition, ...data.style }} className="w-1 absolute">
        <div
          className="absolute select-none gap-5 truncate grid items-center text-xs whitespace-no-wrap top-0 rounded rounded-bl-none px-5 py-2 z-10"
          style={labelStyle}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <span
            className="w-20 h-20 bg-no-repeat bg-center bg-cover rounded-percent50"
            style={{
              backgroundImage: !isHovered ? `url('${data?.member?.avatar}')` : undefined,
            }}
          ></span>
          <span>{data?.member?.firstname}</span>
        </div>
      </div>
    ) : (
      <></>
    );
  };

  const handleRenderRect = (props) => {
    const { selectionRect, data } = props;
    const selectionStyle: CSSProperties = {
      // Add a opacity to the background color
      backgroundColor: `${data?.style?.backgroundColor}66`,
    };

    return (
      <div
        style={{ ...selectionStyle, ...selectionRect }}
        className="absolute pointer-events-none"
      />
    );
  };

  return (
    <CursorOverlay
      {...props}
      cursors={dynamicCursors}
      onRenderCaret={handleRender}
      onRenderSelectionRect={handleRenderRect}
    />
  );
};
